// extracted by mini-css-extract-plugin
module.exports = {"container":"HzMrNt_","container__extraPadding":"_27WxLkc","hitArea":"_3t1TyDI","chevronRight":"_1O_W2Gl","chevronLeft":"_3yHM4U1"};